// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"threeModel__wrapper__1Qk5X","three":"threeModel__three__2xjsO"};